<template>
  <v-container fill-height wrap align-center justify-center>
      <v-flex xs12 lg10 offset-md-1>
        <v-layout align-center justify-center :wrap="!$vuetify.breakpoint.mdAndUp">
          <v-flex xs6>
            <v-hover>
              <template v-slot:default="{ hover }">
                <v-card
                  elevation="6"
                  hover
                  :style="($vuetify.breakpoint.mdAndUp ? 'z-index: 2; margin-right: -60px;' : '')"
                >
                  <v-img :aspect-ratio="0.7207245156" src="@/assets/cover.png" />
                  <v-fade-transition>
                    <v-overlay v-if="hover" absolute color="accent" opacity="0.75">
                      <v-btn icon @click="bookClicked">
                        <v-icon>get_app</v-icon>
                      </v-btn>
                    </v-overlay>
                  </v-fade-transition>
                </v-card>
              </template>
            </v-hover>
          </v-flex>
          <v-flex xs11>
            <v-card
              elevation="2"
              :style="'z-index: 1;'
              + ($vuetify.breakpoint.mdAndUp ?
              'margin-left: -30px; padding-right: 30px' : 'margin-top: 10px')"
            >
              <v-card-title
                :style="($vuetify.breakpoint.mdAndUp ? 'margin-left: 40px;' : '')"
              >Neurorradiologia Integrada</v-card-title>
              <v-card-text :style="($vuetify.breakpoint.mdAndUp ? 'margin-left: 42px;' : '')">
                <p>Destinada a médicos e estudantes nas diversas etapas de formação.</p>
                <p>Este site disponibiliza o livro em PDF para download
                   e também as seguintes funcionalidades:</p>
                <v-layout pa-3 wrap>
                  <v-flex xs12 md6 my-3>
                    <v-layout justify-start align-start>
                      <v-btn fab small color="accent" @click="$router.push('atlas')">
                        <v-icon>school</v-icon>
                      </v-btn>
                      <div style="margin-left: 8px">
                        <h3 class="accent--text">Atlas:</h3>
                        <p>Explicação sobre atlas</p>
                      </div>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 md6 my-3>
                    <v-layout justify-start align-start>
                      <v-btn fab small color="accent" @click="$router.push('exames')">
                        <v-icon>assignment_ind</v-icon>
                      </v-btn>
                      <div style="margin-left: 8px">
                        <h3 class="accent--text">Exames:</h3>
                        <p>Explicação sobre exames</p>
                      </div>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 md6 my-3>
                    <v-layout justify-start align-start>
                      <v-btn fab small color="accent" @click="videoClicked">
                        <v-icon>play_circle_fill</v-icon>
                      </v-btn>
                      <div style="margin-left: 8px">
                        <h3 class="accent--text">Vídeos:</h3>
                        <p>Explicação sobre vídeos</p>
                      </div>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 md6 my-3>
                    <v-layout justify-start align-start>
                      <v-btn fab small color="accent" @click="$router.push('exercicios')">
                        <v-icon>edit</v-icon>
                      </v-btn>
                      <div style="margin-left: 8px">
                        <h3 class="accent--text">Exercícios:</h3>
                        <p>Explicação sobre exercícios</p>
                      </div>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 md6 my-3>
                    <v-layout justify-start align-start>
                      <v-btn fab small color="accent" @click="$router.push('resumos')">
                        <v-icon>insert_drive_file</v-icon>
                      </v-btn>
                      <div style="margin-left: 8px">
                        <h3 class="accent--text">Resumos:</h3>
                        <p>Explicação sobre resumos</p>
                      </div>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 md6 my-3>
                    <v-layout justify-start align-start>
                      <v-btn fab small color="accent" @click="$router.push('contato')">
                        <v-icon>chat</v-icon>
                      </v-btn>
                      <div style="margin-left: 8px">
                        <h3 class="accent--text">Contato:</h3>
                        <p>Informações, email e links de contato</p>
                      </div>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>

          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs11 lg9 offset-md-1 class="mt-5">
        <v-card>
          <v-card-text>
        <p>O site “Neurorradiologia Integrada” surgiu no intuito de ajudar o aprendizado dos alunos da graduação de Medicina, tanto do ciclo básico, como do clínico, funcionando como uma ferramenta para o estudo de forma livre. Víamos, na prática, a neurofobia! E como médicos, sabemos qual deve ser o seu tratamento: a integração.</p>

          <p>Ao longo da elaboração do material, percebemos que muitos médicos poderiam se beneficiar de um conteúdo mais didático, principalmente porque esse material é de fato integrado. Procuramos o ponto de vista de diversas especialidades médicas, com ênfase na Neurologia, Neuropediatra, Neurocirurgia, Patologia e Genética, além, é claro da Neurorradiologia e da opinião dos estudantes.</p>

          <p>Alguns conceitos básicos, muitas vezes ignorados nos tratados de Radiologia, são abordados no e-book deste site, buscando agregar maior conhecimento e facilitar a compreensão desta área, assim como trazer maior integração clínico-radiológica entre os diversos campos médicos.</p>

          <p>Como professora, eu não poderia escrever um material para a graduação e deixar de falar sobre dois conceitos tão fundamentais dentro da medicina, e que são verdadeiros alicerces da nossa ciência...</p>

          <p>“A clínica é soberana!”
          “É fundamental o contexto clínico para a valorização de uma imagem!”
            <span class="font-weight-bold">(autores desconhecidos)</span></p>

          <p>Dentro da neurorradiologia, essas frases não poderiam ser mais verdadeiras! Temos várias imagens semelhantes que representam doenças clínicas completamente diferentes, assim como temos vários achados de imagem que não representam doença alguma, já que não são ancorados em uma sintomatologia pertinente.</p>

          <p>Então, querido leitor, nada de ignorar a história e o exame físico buscando “um atalho” nos métodos diagnósticos, já que até para a valorização de um achado é fundamental uma história clínica bem-feita. Sem contar que uma boa conversa é a verdadeira base de uma boa relação médico-paciente, algo fundamental, desde os tempos dos “barbeiros”, até os dias de hoje.</p>

          <p><span class="font-weight-bold">Ps:</span> como Radiologista, digo mais... se a conversa não for com o paciente, que seja com o médico solicitante! Só assim crescemos como profissionais.</p>

          <p class="font-weight-bold">Esther de Alencar Araripe Falcão Feitosa.</p>
          </v-card-text>
        </v-card>
      </v-flex>
    <v-dialog v-model="welcomeDialog" max-width="500px" scrollable>
      <v-card>
        <v-card-title class="primary white--text">Bem Vindo!</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px;">
          <p>O site “Neurorradiologia Integrada” surgiu no intuito de ajudar o aprendizado dos alunos da graduação de Medicina, tanto do ciclo básico, como do clínico, funcionando como uma ferramenta para o estudo de forma livre. Víamos, na prática, a neurofobia! E como médicos, sabemos qual deve ser o seu tratamento: a integração.</p>

          <p>Ao longo da elaboração do material, percebemos que muitos médicos poderiam se beneficiar de um conteúdo mais didático, principalmente porque esse material é de fato integrado. Procuramos o ponto de vista de diversas especialidades médicas, com ênfase na Neurologia, Neuropediatra, Neurocirurgia, Patologia e Genética, além, é claro da Neurorradiologia e da opinião dos estudantes.</p>

          <p>Alguns conceitos básicos, muitas vezes ignorados nos tratados de Radiologia, são abordados no e-book deste site, buscando agregar maior conhecimento e facilitar a compreensão desta área, assim como trazer maior integração clínico-radiológica entre os diversos campos médicos.</p>

          <p>Como professora, eu não poderia escrever um material para a graduação e deixar de falar sobre dois conceitos tão fundamentais dentro da medicina, e que são verdadeiros alicerces da nossa ciência...</p>

          <p>“A clínica é soberana!”
          “É fundamental o contexto clínico para a valorização de uma imagem!”
            <span class="font-weight-bold">(autores desconhecidos)</span></p>

          <p>Dentro da neurorradiologia, essas frases não poderiam ser mais verdadeiras! Temos várias imagens semelhantes que representam doenças clínicas completamente diferentes, assim como temos vários achados de imagem que não representam doença alguma, já que não são ancorados em uma sintomatologia pertinente.</p>

          <p>Então, querido leitor, nada de ignorar a história e o exame físico buscando “um atalho” nos métodos diagnósticos, já que até para a valorização de um achado é fundamental uma história clínica bem-feita. Sem contar que uma boa conversa é a verdadeira base de uma boa relação médico-paciente, algo fundamental, desde os tempos dos “barbeiros”, até os dias de hoje.</p>

          <p><span class="font-weight-bold">Ps:</span> como Radiologista, digo mais... se a conversa não for com o paciente, que seja com o médico solicitante! Só assim crescemos como profissionais.</p>

          <p class="font-weight-bold">Esther de Alencar Araripe Falcão Feitosa.</p>

        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="accent" @click="welcomeDialog = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    welcomeDialog: false,
  }),
  methods: {
    bookClicked() {
      window.open('https://drive.google.com/file/d/1jca15R6G-fzLUecnTF6hPDDiVHKtzPGH/view?usp=sharing');
    },
    videoClicked() {
      window.open('https://www.youtube.com/channel/UCRzazidHFZXDg-GFfNkDOkg/playlists');
    }
  },
};
</script>
